import { Alert, Button } from '@mui/material';
import { Drawer } from '../../Atoms/Drawer';
import { Text } from '../../Atoms/Text';
import { McpAccessProfile } from '../../../Api/McpAccess';
import { useMcpAccessAudit } from '../../../store/McpAccessAudit';
import { McpAccessAuditTable } from './McpAccessAuditTable';

export interface McpAccessAuditDrawerProps {
  profile: McpAccessProfile | null;
  open: boolean;
  onClose: () => void;
}

export const McpAccessAuditDrawer = ({ profile, open, onClose }: McpAccessAuditDrawerProps) => {
  const accessId = open && profile ? profile.access_id : null;
  const { invocations, page, pageSize, totalCount, loading, error, setPaginationModel, reload } =
    useMcpAccessAudit(accessId);

  if (!profile) return null;

  return (
    <Drawer
      data-testid="mcp-access-audit-drawer"
      show={open}
      setShow={() => onClose()}
      title="MCP Activity"
      subtitle={<Text size="lg">{profile.title}</Text>}
      description="Recent MCP tools/call activity for this access profile.">
      {error ? (
        <Alert
          severity="error"
          data-testid="mcp-access-audit-error"
          action={
            <Button
              color="inherit"
              size="small"
              onClick={reload}
              data-testid="mcp-access-audit-retry">
              Retry
            </Button>
          }>
          {error}
        </Alert>
      ) : (
        <McpAccessAuditTable
          invocations={invocations}
          loading={loading}
          page={page}
          pageSize={pageSize}
          totalCount={totalCount}
          onPaginationModelChange={setPaginationModel}
        />
      )}
    </Drawer>
  );
};
